// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__31x1x","content":"LayoutSettings_content__3sevH"};